interface AuthState {
    token: string | null;
    username: string | null;
}

const STORAGE_KEY = 'keyvault.auth';

function load(): AuthState {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) return JSON.parse(raw);
    } catch {}
    return { token: null, username: null };
}

const initial = load();

class AuthStore {
    token = $state<string | null>(initial.token);
    username = $state<string | null>(initial.username);

    get isLoggedIn() {
        return !!this.token;
    }

    login(token: string, username: string) {
        this.token = token;
        this.username = username;
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ token, username }));
    }

    logout() {
        this.token = null;
        this.username = null;
        localStorage.removeItem(STORAGE_KEY);
    }
}

export const auth = new AuthStore();